import * as React from 'react';
import { View, Text, Modal, TextInput, Pressable } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Icon } from 'react-native-elements';
import useMediumScreen from 'hooks/useMediumScreen';
import RefundAuthorizationCodeVerificationProps from 'types/components/RefundAuthorizationCodeVerificationProps';
import { styles } from 'styles/components/refundAuthorizationCodeVerification';
import OrderContext from 'contexts/OrderContext';
import { validateRefundValidationCode } from 'services/ordersService';

export default ({
  title,
  visible,
  setVisible,
  generalColor,
  onHandleModal,
}: RefundAuthorizationCodeVerificationProps): JSX.Element => {
  const mediumScreen = useMediumScreen();
  const [code, setCode] = React.useState<string>('');
  const [error, setError] = React.useState<string>('');
  const { t } = useTranslation();
  const { currentVenue, currentCommerce } = React.useContext(OrderContext);

  const validateCode = async () => {
    const body = {
      code: parseInt(code),
      commerceEditorId: currentCommerce?.editorId,
      venueEditorId: currentVenue?.editorId,
    };
    const response = await validateRefundValidationCode(body);
    if (response.result) {
      onHandleModal();
    } else {
      setError(t('invalid-authorization-code'));
    }
  };

  return (
    <Modal visible={visible} transparent={true} style={styles.modal}>
      <View style={styles.container}></View>
      <View style={styles.modalBox}>
        <View style={mediumScreen ? styles.modalContentLarge : styles.modalContentSmall}>
          <View style={[styles.modaIconContainer, { backgroundColor: generalColor ?? '#FFFFFF' }]}>
            <Icon
              name={'alert-circle-outline'}
              type={'ionicon'}
              color={'#FFFFFF'}
              size={40}
              containerStyle={styles.iconContainer}
            />
          </View>
          <View style={styles.modalTextContainer}>
            <Text style={styles.modalText}>{title}</Text>
          </View>
          {error ? <Text style={styles.errorText}>{error}</Text> : <></>}
          <View style={{ alignItems: 'center' }}>
            <>
              <TextInput
                keyboardType="number-pad"
                style={[styles.textInput]}
                onChangeText={setCode}
                placeholder={t('authorization-code')}
                value={code}
                maxLength={6}
                placeholderTextColor={'#959393'}
                onFocus={() => setError('')}
              ></TextInput>

              <Pressable
                style={[
                  styles.topRowOrderItemOnOrdersListLarge,
                  { backgroundColor: generalColor ?? '#FFFFFF' },
                  !code && styles.confirmPaymentBtnDisabled,
                ]}
                onPress={() => {
                  validateCode();
                }}
                disabled={!code}
              >
                <View>
                  <Text style={[styles.topRowText, !code && styles.confirmPaymentBtnDisabled, { color: '#fff' }]}>
                    {t('confirm-button-text')}
                  </Text>
                </View>
              </Pressable>
              <Pressable style={[styles.topRowOrderItemOnOrdersListLarge]} onPress={() => setVisible(false)}>
                <View>
                  <Text style={styles.topRowText}>{t('cancel')}</Text>
                </View>
              </Pressable>
            </>
          </View>
        </View>
      </View>
    </Modal>
  );
};
